import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { UseQueryConfig } from '@/api/types';
import { ReleaseNotesQueryParams } from '@/api/apis/release-notes';
import { opobffReleaseNotesQueryKeys } from './opobff-release-notes.keys';

export const opobffReleaseNotesQueries = {
  list: (params?: ReleaseNotesQueryParams) =>
    queryOptions({
      queryKey: opobffReleaseNotesQueryKeys.list(params),
      queryFn: () => api.opobffReleaseNotes.getReleaseNotes(params),
    }),
};

export const useOpobffReleaseNotesQuery = (params?: ReleaseNotesQueryParams, options?: UseQueryConfig) => {
  return useQuery({ ...opobffReleaseNotesQueries.list(params), ...options });
};
